import classNames from 'classnames';
import PropTypes from 'prop-types';

import style from './style.module.css';

const Block = ({ children, padding = 'MEDIUM', className = '', backgroundColor = '', onClick = null }) => (<div
  className={classNames(style.block, className, { [style[`padding-${padding.toString().toLowerCase()}`]]: padding })}
  style={{ ...(backgroundColor ? { background: backgroundColor } : {}) }}
  onClick={onClick}
>
  {children}
</div>
);

Block.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  padding: PropTypes.oneOf(['NONE', 'SMALL', 'MEDIUM', 'BIG', 'HUGE']),
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default Block;
